import React from 'react';
import { Content, Row, Col, Title, Pagination, Button } from 'components';
import { SideMenu } from '../components';
import { DatePicker, Spin } from 'antd';
import PresentsListTable from '../components/PresentsListTable';

const TAP = [
  {
    label: '선물한 내역',
    value: 'GIVE',
  },
  {
    label: '선물 받은 내역',
    value: 'RECEIVE',
  },
];

const PERIOD = [
  {
    label: '1개월',
    value: 1,
    key: 'month',
  },
  {
    label: '3개월',
    value: 3,
    key: 'month',
  },
  {
    label: '6개월',
    value: 6,
    key: 'month',
  },
  {
    label: '1년',
    value: 1,
    key: 'year',
  },
];

const COUNT = 5;

const MypagePresentsPresenter = (props) => {
  /* ===== Props ===== */
  const {
    selectedTab,
    setSelectedTab,
    currentPage,
    setCurrentPage,
    screenSize,

    data,
    onExtension,
    isLoading,
    selectedDate,
    setSelectedDate,
    today,
    onCancel,
  } = props;

  /* ===== Variables ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      paddingBottom: 32,
      borderBottom: '2px solid var(--black-color)',
    },
    tabContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 32,
      borderBottom: '2px solid var(--black-color)',
    },
    tab: {
      width: screenSize >= 768 ? 160 : 130,
      height: screenSize >= 768 ? 66 : 55,
      lineHeight: screenSize >= 768 ? '66px' : '55px',
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: screenSize >= 768 ? 16 : 14,
      border: '1px solid gray',
      backgroundColor: 'transparent',
      color: 'gray',
    },
    activeTab: {
      fontWeight: 'bold',
      backgroundColor: 'black',
      color: 'white',
      border: '2px solid black',
    },
    emptyState: {
      textAlign: 'center',
      padding: 20,
      fontSize: 16,
      color: 'gray',
    },
    paginationButton: {
      color: 'var(--black-color)',
      width: 28,
      height: 28,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    buttonGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    button: {
      width: '25%',
      borderRadius: '0',
      border: '1px solid var(--light-gray-color)',
      backgroundColor: '#fff',
      color: 'var(--light-gray-color)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: screenSize >= 768 ? 16 : 14,
      cursor: 'pointer',
    },
    activeButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
    },
  };

  const [date, setDate] = React.useState([1, 'month']);
  const [range, setRange] = React.useState(selectedDate);

  /* ===== Function ===== */
  const handleRange = (t, v1, v2) => {
    const type = t.toLocaleUpperCase();

    switch (type) {
      case 'CLICK':
        setDate([v1, v2]);
        break;
      case 'SELECT':
        setRange([v1, v2]);
        break;
      default:
        break;
    }
  };

  /* ===== Hooks ===== */
  React.useEffect(() => {
    const start = today.subtract(date[0], date[1]).startOf('day');

    setRange([start, today.endOf('day')]);
  }, [date]);
  /* ===== Render ===== */
  return (
    <Spin spinning={isLoading}>
      <Content
        maxWidth={1820}
        padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
      >
        <Row gutter={25}>
          <Col x={0} md={1} xl={2}></Col>
          <Col x={0} md={6} xl={4}>
            <SideMenu />
          </Col>
          <Col x={24} md={16} xl={16}>
            <Content
              maxWidth={'100%'}
              padding={
                screenSize >= 1200
                  ? '0 0 0 95px'
                  : screenSize >= 768
                  ? '0 0 0 20px'
                  : '0'
              }
            >
              {/* 주문내역 */}
              <Content maxWidth={'100%'} padding={0}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Title
                    style={{
                      fontSize:
                        screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                      fontWeight: 700,
                    }}
                  >
                    선물 내역
                  </Title>
                  {/* Taps */}

                  <div style={styles.tabContainer}>
                    {TAP.map((tap) => (
                      <div
                        key={tap.value} // ✅ tap.label이 아니라 tap.value를 key로 사용
                        style={{
                          ...styles.tab,
                          ...(selectedTab === tap.value
                            ? styles.activeTab
                            : {}),
                        }}
                        onClick={() => {
                          setSelectedTab(tap.value);
                          setCurrentPage(1);
                        }}
                      >
                        {tap.label}
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '32px 0',
                      marginBottom: 80,
                      borderBottom: '1px solid #ddd',
                      flexDirection: screenSize >= 768 ? 'unset' : 'column',
                      gap: screenSize >= 768 ? 'unset' : '10px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        width: screenSize >= 768 ? '51.44%' : '100%',
                        height: 48,
                      }}
                    >
                      <div style={styles.buttonGroup}>
                        {PERIOD.map((period) => (
                          <button
                            key={period.label}
                            style={{
                              ...styles.button,
                              ...(date[0] === period.value &&
                              date[1] === period.key
                                ? styles.activeButton
                                : {}),
                            }}
                            onClick={() => {
                              handleRange('CLICK', period.value, period.key);
                              setCurrentPage(1); // 기간 변경 시 페이지를 초기화
                            }}
                          >
                            {period.label}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: screenSize >= 768 ? '46.3%' : '100%',
                      }}
                    >
                      <DatePicker.RangePicker
                        style={{
                          width: '64%',
                          height: 48,
                          border: '1px solid var(--light-gray-color)',
                        }}
                        format={'YYYY.MM.DD'}
                        value={[range[0], range[1]]}
                        placeholder={['시작일', '종료일']}
                        onChange={([start, end]) =>
                          handleRange('select', start, end)
                        }
                      />
                      <Button
                        style={{
                          width: '31.12%',
                          borderRadius: '0',
                          fontWeight: 700,
                          fontSize: screenSize >= 768 ? 16 : 14,
                          backgroundColor: 'var(--white-color)',
                          color: 'var(--black-color)',
                          border: '1px solid var(--black-color)',
                        }}
                        onClick={() => setSelectedDate(range)}
                      >
                        조회
                      </Button>
                    </div>
                  </div>
                </div>

                {/* OrderListTable */}
                <div>
                  {/* {console.log(data)} */}
                  <PresentsListTable
                    presentstype={selectedTab}
                    orders={data[selectedTab]?.slice(
                      (currentPage - 1) * COUNT,
                      currentPage * COUNT
                    )}
                    isSentOrders={selectedTab === 'GIVE'} // 선물한 내역인지 여부를 전달
                    onExtension={onExtension}
                    onCancel={onCancel}
                  />
                </div>
              </Content>
              {/* 주문내역 끝 */}
            </Content>

            {/* SECTION: 페이지네이션 */}
            <Content maxWidth={'100%'} padding={0} style={{ marginTop: 100 }}>
              <Pagination
                total={data[selectedTab]?.length}
                pageSize={COUNT}
                current={currentPage}
                onChange={(e) => setCurrentPage(e)}
                showPage={5}
                buttonStyle={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: '#999999',
                  background: 'none',
                  width: 28,
                  height: 28,
                }}
                isButton={true}
                activeStyle={{
                  color: `var(--black-color) !important`,
                  borderBottom: '2px solid #111111',
                }}
                hoverStyle={{ color: `var(--black-color) !important` }}
                navStyle={{ border: '1px solid var(--black-color)' }}
                isLatestButton={true}
              />
            </Content>
          </Col>
          <Col x={0} md={1} xl={2}></Col>
        </Row>
      </Content>
    </Spin>
  );
};

export default MypagePresentsPresenter;
